import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  LinearProgress,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  TextField,
  InputAdornment,
  Collapse,
  Pagination,
  PaginationItem,
  Select as MuiSelect,
  MenuItem,
  Checkbox as MuiCheckbox,
  ListItemText,
  ListSubheader,
  createTheme,
} from "@mui/material";
import { useWindowDimensions } from "react-native";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header";
import {
  getAllAnalyst,
  getAllOrganizer,
} from "../../redux/actions/adminAction";
import { Link } from "react-router-dom";
import EditDialog from "./EditDialog";
import { MatchCard } from "./MatchCard";
import { useQueryClient, useQuery } from "react-query";
import axios from "axios";
import { MAIN_API } from "../../config/stepoutAPI";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import {
  CloseOutlined,
  DownloadOutlined,
  FilterListOutlined,
  DownloadSharp,
  FilterList,
  InfoOutlined,
  SearchOutlined,
  SortOutlined,
  ArrowBack,
  ArrowForward,
  SportsSoccer,
} from "@mui/icons-material";
import moment from "moment";
import Select from "react-select";
import toast from "react-hot-toast";

const CustomDateInput = forwardRef(({ value, onClick, className }, ref) => (
  <Button
    className={className}
    onClick={onClick}
    ref={ref}
    sx={{
      height: "38px",
      fontSize: "13px",
      border: "1px solid var(--border-1)",
      borderRadius: "8px",
      color: value ? "var(--text-1)" : "var(--text-2)",
      backgroundColor: "var(--surface-1)",
      textTransform: "none",
      fontWeight: "400",
      px: 2,
      justifyContent: "flex-start",
      "&:hover": {
        borderColor: "var(--text-2)",
        backgroundColor: "var(--surface-1)",
      },
    }}
  >
    {value || "Select date"}
  </Button>
));

const analysisOptions = [
  { value: 1, label: "Match Created" },
  { value: 2, label: "Video Uploaded" },
  
  { value: 4, label: "Resources Assigned" },
  { value: 5, label: "Analysis In Progress" },
  { value: 3, label: "Analysis Done" },
    { value: 8, label: "Mark for Review" },
  { value: 6, label: "Review In Progress" },
 

  { value: 9, label: "Issue Found" },
   { value: 7, label: "Completed" },
];

const sortOptions = [
  { label: "Match ID", value: "desc" },
  { label: "Created Date", value: "created_at" },
];

const FilterSelectField = ({ options, value, onChange, placeholder = "Select", searchable = false, labelKey = "label", valueKey = "value" }) => {
  const [searchText, setSearchText] = useState("");
  const selected = value || [];
  const filtered = searchable
    ? options.filter(o => (o[labelKey] || "").toLowerCase().includes(searchText.toLowerCase()))
    : options;
  const visibleValues = filtered.map((o) => o[valueKey]);

  const selectedVisibleCount = visibleValues.filter((v) => selected.includes(v)).length;
  const allSelected = visibleValues.length > 0 && selectedVisibleCount === visibleValues.length;

  const SELECT_ALL = "__SELECT_ALL__";
  const toggleSelectAll = () => {
    const vals = filtered.map((o) => o[valueKey]);
    if (allSelected) {
      onChange(selected.filter((v) => !vals.includes(v)));
    } else {
      onChange(Array.from(new Set([...selected, ...vals])));
    }
  };
  const handleChange = (e) => {
    const v = e.target.value;
    // Clicking the Select All row injects the sentinel — intercept it.
    if (Array.isArray(v) && v.includes(SELECT_ALL)) {
      toggleSelectAll();
      return;
    }
    onChange(v);
  };
  return (
    <MuiSelect
      multiple
      displayEmpty
      value={value}
      onChange={handleChange}
      renderValue={(selected) => {
        if (selected.length === 0) return <span style={{ color: "var(--text-2)", fontSize: "12px" }}>{placeholder}</span>;
        if (selected.length === 1) {
          const item = options.find(o => o[valueKey] === selected[0]);
          return <span style={{ fontSize: "12px", color: "var(--text-1)" }}>{item?.[labelKey] ?? selected[0]}</span>;
        }
        return <span style={{ fontSize: "12px", color: "var(--text-1)", fontWeight: 500 }}>Selected ({selected.length})</span>;
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            backgroundColor: "var(--surface-1)",
            border: "1px solid var(--border-1)",
            borderRadius: "8px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            maxHeight: 260,
          },
        },
        disableAutoFocusItem: true,
      }}
      sx={{
        height: "38px",
        fontSize: "12px",
        borderRadius: "8px",
        backgroundColor: "var(--surface-2)",
        color: "var(--text-1)",
        width: "100%",
        "& .MuiOutlinedInput-notchedOutline": { borderColor: "var(--border-1)" },
        "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "var(--text-2)" },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(232,108,0,0.6)" },
        "& .MuiSelect-icon": { color: "var(--text-2)", fontSize: "18px" },
      }}
    >
      {searchable && (
        <ListSubheader sx={{ backgroundColor: "var(--surface-1)", px: 1, pt: 1, pb: 0.5, lineHeight: "normal" }}>
          <TextField
            size="small"
            fullWidth
            autoFocus
            placeholder="Search..."
            value={searchText}
            onChange={(e) => { e.stopPropagation(); setSearchText(e.target.value); }}
            onKeyDown={(e) => e.stopPropagation()}
            InputProps={{
              startAdornment: <InputAdornment position="start"><SearchOutlined sx={{ fontSize: 15, color: "var(--text-2)" }} /></InputAdornment>,
              sx: { fontSize: "12px", borderRadius: "8px", height: "32px", backgroundColor: "var(--surface-2)", "& fieldset": { borderColor: "var(--border-1)" } },
            }}
          />
        </ListSubheader>
      )}
      {filtered.length === 0 && (
        <MenuItem disabled sx={{ fontSize: "12px", color: "var(--text-2)" }}>No results</MenuItem>
      )}
      {filtered.length > 0 && (
        <MenuItem
          value={SELECT_ALL}
          sx={{ fontSize: "12px", py: 0.5, color: "var(--text-1)", gap: 0.5, fontWeight: 600, borderBottom: "1px solid var(--border-1)" }}
        >
          <MuiCheckbox
            checked={allSelected}
            indeterminate={selectedVisibleCount > 0 && !allSelected}
            size="small"
            sx={{ p: 0.5, color: "var(--text-2)", "&.Mui-checked": { color: "rgba(232,108,0,1)" }, "&.MuiCheckbox-indeterminate": { color: "rgba(232,108,0,1)" } }}
          />
          <ListItemText primary={allSelected ? "Deselect All" : "Select All"} primaryTypographyProps={{ fontSize: "12px", fontWeight: 600, color: "var(--text-1)" }} />
        </MenuItem>
      )}
      {filtered.map(option => (
        <MenuItem key={option[valueKey]} value={option[valueKey]} sx={{ fontSize: "12px", py: 0.5, color: "var(--text-1)", gap: 0.5 }}>
          <MuiCheckbox
            checked={selected.includes(option[valueKey])}
            size="small"
            sx={{ p: 0.5, color: "var(--text-2)", "&.Mui-checked": { color: "rgba(232,108,0,1)" } }}
          />
          <ListItemText primary={option[labelKey]} primaryTypographyProps={{ fontSize: "12px", color: "var(--text-1)" }} />
        </MenuItem>
      ))}
    </MuiSelect>
  );
};

const headerColumns = [
  { label: "ID", align: "left", sticky: true, width: "70px" },
  { label: "Match Details", align: "center" },
  { label: "Analysts", align: "center" },
  { label: "Video Uploaded Time", align: "left", width: "110px" },
  { label: "Assign Date", align: "left", width: "110px" },
  { label: "Analysis Start Time", align: "left", width: "110px" },
  { label: "Progress %", align: "center", width: "100px" },
  { label: "Analysis End Time", align: "left", width: "110px" },
  {label: "Full Completion Time", align: "left", width: "110px" },
  // {label: "Current Analysis Time", align: "left", width: "110px" },
  { label: "Last Tagged Time", align: "center", width: "110px" },
  { label: "Due Date", align: "left", width: "110px" },
  { label: "Status", align: "center", width: "120px" },
  { label: "Reviewers", align: "center" },
  { label: "Account Availability", align: "center" },
  {
    label: "Analyst Screen Time",
    align: "center",
    width: "100px",
    tooltip:
      "Its the time duration for which the tagging portal is open on the analyst mobile phone while tagging this match.",
  },
  {
    label: "Analysis TAT",
    align: "center",
    width: "100px",
    tooltip: "Turnaround time is from Analysis In Progress to Analysis Done.",
  },
  {
    label: "Reviewer TAT",
    align: "center",
    width: "100px",
    tooltip: "Turnaround time is from Review In Progress to Full Completion.",
  },
  {
    label: "Overall TAT",
    align: "center",
    width: "100px",
    tooltip:
      "Total analysis turnaround is from Analysis In Progress to Full Completion, including analysis time, reviewer time, and time spent fixing analyst errors.",
  },
  {
    label: "Client TAT",
    align: "center",
    width: "100px",
    tooltip:
      "Client turnaround time is from Video Uploaded Time to Full Completion Time.",
  },
  { label: "Game Time", align: "center", width: "90px" },
  { label: "Total Game Time", align: "center", width: "90px" },
  { label: "Actions", align: "center", width: "120px", colSpan: 2 },
   { label: "History", align: "center", width: "120px", colSpan: 2 },
];

export const ManagementScreen = () => {
  const [openEdit, setOpenEdit] = React.useState({ data: null, show: false });

  const [searchMatchId, setSearchMatchId] = useState("");
  const [selectAnalyzedArray, setSelectAnalyzedArray] = useState();
  const [searchByAnalyst, setSearchByAnalyst] = useState();
  const [selectedAnalystArray, setSelectedAnalystArray] = useState();
  const [selectedReviewerArray, setSelectedReviewerArray] = useState();
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // Bumped to force the status Multiselect to remount when Select All / Clear
  // changes the selection programmatically (the lib doesn't react to
  // selectedValues changes after mount otherwise).
  const [dateFilterKey, setDateFilterKey] = useState(0);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");

  const [searchClicked, setSearchClicked] = useState(false);
  const [filterShown, setFilterShown] = useState(false);
  const [searchToken, setSearchToken] = useState(0);
  const [sortBy, setSortBy] = useState({ label: "Match ID", value: "desc" });

  const { width } = useWindowDimensions();
  const isMobile = width < 850;

  const [, setCurrentPage] = useState(1);
  const [, setTotalPages] = useState(1);
  const [pageSize] = useState(20);
  const [pageLinks, setPageLinks] = useState([]);
  const [currentOffset, setCurrentOffset] = useState(0);

  const { fetchingMatches } = useSelector((state) => state.admin);
  const { token, isAdmin } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleRefetch = async () => {
    try {
      await queryClient.invalidateQueries(["allMatches"]);
      await refetch();
    } catch (e) {
      console.error("Refetch error:", e);
    } finally {
      setSearchClicked(false);
    }
  };

  const getDownloadData = async () => {
    const isMatchIdRange = searchMatchId?.includes("-");
    const idStart = isMatchIdRange ? parseInt(searchMatchId.split("-")[0].trim()) : null;
    const idEnd = isMatchIdRange ? parseInt(searchMatchId.split("-")[1].trim()) : null;

    try {
      const { data } = await axios({
        method: "POST",
        url: `${MAIN_API}getAllMatches/v2/`,
        data: {
          source: "analyst_portal",
          id: !isMatchIdRange && searchMatchId ? parseInt(searchMatchId) : null,
          id_start: idStart,
          id_end: idEnd,
          analyst_list: selectedAnalystArray,
          reviewer_list: selectedReviewerArray,
          // The Status filter drives both normal and date-range filtering.
          analysis_status: selectAnalyzedArray,

          date_end: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
          date_start: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
          date_filter_status: startDate && endDate ? selectAnalyzedArray || [] : [],
          order: sortBy ? sortBy.value : null,
          is_download_csv: true,
        },
        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });
      return data?.response_data?.data;
    } catch (error) {
      throw error;
    }
  };

  const getStatusLabel = (statusValue) => {
    const found = analysisOptions.find((option) => option.value === statusValue);
    return found ? found.label : "NA";
  };

  const formatSecondsToHrsMins = (seconds) => {
    if (seconds === null || seconds === undefined || seconds === 0) return "NA";
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    return `${hrs}hrs ${mins}mins`;
  };

  const formatTimeFromSecondsToMinutes = (seconds) => {
    const mins = Math.floor(seconds / 60);
    return `${mins}mins`;
  };

  const formatDurationToMinutes = (value) => {
    if (value === null || value === undefined || value === "" || value === "NA") return "NA";
    if (typeof value === "number") return `${value}mins`;
    const duration = String(value).trim();
    const hoursMatch = duration.match(/(\d+)\s*h(?:ou)?rs?/i);
    const minutesMatch = duration.match(/(\d+)\s*m(?:in)?s?/i);
    if (!hoursMatch && !minutesMatch) return duration;
    const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
    const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;
    return `${hours * 60 + minutes}mins`;
  };

  const transformDataForCSV = (rawMatches) => {
    if (!rawMatches || !Array.isArray(rawMatches)) return [];
    if (rawMatches.length > 0 && rawMatches[0] && rawMatches[0]["Match ID"] !== undefined) {
      return rawMatches.map((match) => ({
        ...match,
        "Game Time": formatDurationToMinutes(match["Game Time"]),
        "Total Game Time": formatDurationToMinutes(match["Total Game Time"]),
      }));
    }
    // return rawMatches.map((match) => ({
    //   "Match ID": match.id,
    //   "Match Details": `${match.team_a_details?.name} vs ${match.team_b_details?.name}`,
    //   Analysts: match.analyst_details?.map((a) => a.name).join(", ") || "NA",
    //   "Assign Date": match.analysis_sense_data?.assigned_date || "NA",
    //   "Start Time": match.analysis_sense_data?.analysis_start_time || "NA",
    //   Progress: match.progress !== null && match.progress !== undefined ? `${match.progress}%` : "NA",
    //   "End Time": match.analysis_sense_data?.analysis_end_time || "NA",
    //   "Current Analysis Time": match.analysis_sense_data?.current_analysis_time || "NA",
    //   "Due date": match.analysis_sense_data?.due_date || "NA",
    //   Status: getStatusLabel(match.status),
    //   Reviewers: match.reviewer_details?.map((item) => item.name).join(", ") || "NA",
    //   "Account Availablity": match.organizer_details?.map((item) => `${item.id} - ${item.name}`).join(", ") || "NA",
    //   "Analysis TAT": formatSecondsToHrsMins(match.analysis_tat),
    //   "Overall TAT": formatSecondsToHrsMins(match.overall_tat),
    //   "Game Time": match.game_time != null ? `${match.game_time}mins` : "NA",
    //   "Total Game Time": match.total_game_time ? formatTimeFromSecondsToMinutes(match.total_game_time) : "NA",
    // }));

    return rawMatches.map((match) => {
      return {
        "Match ID": match.id,
        "Match Details": `${match.team_a_details?.name} vs ${match.team_b_details?.name}`,
        Analysts: match.analyst_details?.map((a) => a.name).join(", ") || "NA",
        "Assign Date": match.analysis_sense_data?.assigned_date || "NA",
        "Analysis Start Time": match.analysis_sense_data?.analysis_start_time || "NA",
        Progress: match.progress !== null && match.progress !== undefined ? `${match.progress}%` : "NA",
        "Analysis End Time": match.analysis_sense_data?.analysis_end_time || "NA",
        "Full Completion Time": match.analysis_sense_data?.full_completion_time || "NA",
        "Current Analysis Time":
          match.analysis_sense_data?.current_analysis_time || "NA",
        "Due date": match.analysis_sense_data?.due_date || "NA",
        Status: getStatusLabel(match.status),
        Reviewers:
          match.reviewer_details?.map((item) => item.name).join(", ") || "NA",
        "Account Availablity":
          match.organizer_details?.map((item) => `${item.id} - ${item.name}`).join(", ") || "NA",
        "Analysis TAT": formatSecondsToHrsMins(match.analysis_tat),
        "Overall Analysis TAT": formatSecondsToHrsMins(match.overall_tat),
        "Client TAT": formatSecondsToHrsMins(match.client_tat),
        "Game Time": match.game_time != null ? `${match.game_time}mins` : "NA",
        "Total Game Time": match.total_game_time
          ? formatTimeFromSecondsToMinutes(match.total_game_time)
          : "NA",
      };
    });
  };

  const triggerBlobDownload = (data, filename) => {
    if (!data || data.length === 0) { alert("No data to download."); return; }
    const headers = Object.keys(data[0]);
    const csvRows = [
      headers.map((h) => `"${h}"`).join(","),
      ...data.map((row) =>
        headers.map((h) => { const val = row[h] ?? ""; return `"${String(val).replace(/"/g, '""')}"`; }).join(",")
      ),
    ];
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const fetchDataAndDownload = async () => {
    setLoading(true);
    try {
      const rawData = await getDownloadData();
      const csvRows = transformDataForCSV(rawData);
      triggerBlobDownload(csvRows, "match_data.csv");
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => { queryClient.removeQueries(["allMatches"]); };
  }, [queryClient]);

  useEffect(() => {
    if (token) {
      dispatch(getAllAnalyst({ token }));
      dispatch(getAllOrganizer({ token }));
    }
  }, [token, dispatch]);

  const allAnalyst = useSelector((state) => state.admin.allAnalyst);

  const _getAllMatches = useCallback(async () => {
    const isMatchIdRange = searchMatchId?.includes("-");
    const idStart = isMatchIdRange ? parseInt(searchMatchId.split("-")[0].trim()) : null;
    const idEnd = isMatchIdRange ? parseInt(searchMatchId.split("-")[1].trim()) : null;

    try {
      const { data } = await axios({
        method: "POST",
        url: `${MAIN_API}getAllMatches/v2/?offset=${currentOffset}&limit=${pageSize}`,
        data: {
          source: "analyst_portal",
          id: !isMatchIdRange && searchMatchId ? parseInt(searchMatchId) : null,
          id_start: idStart,
          id_end: idEnd,
          analyst_list: selectedAnalystArray,
          reviewer_list: selectedReviewerArray,
          // The Status filter drives both normal and date-range filtering.
          analysis_status: selectAnalyzedArray,
          date_end: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
          date_start: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
          date_filter_status: startDate && endDate ? selectAnalyzedArray || [] : [],
          order: sortBy ? sortBy.value : null,
        },
        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });
      setTotalPages(Math.ceil((data?.response_data?.data?.count || 1) / pageSize));
      setPageLinks(data?.response_data?.data?.links || []);
      const current = (data?.response_data?.data?.links || []).find((l) => l.is_current);
      setCurrentPage(current ? current.counter : 1);
      return data?.response_data?.data;
    } catch (error) {
      throw error;
    }
  }, [selectedAnalystArray, selectedReviewerArray, selectAnalyzedArray, endDate, searchMatchId, startDate, sortBy, currentOffset, pageSize, token]);

  const {
    data: _allMatches,
    isLoading: isLoadingMatches,
    refetch,
    isRefetching,
  } = useQuery(
    ["allMatches", currentOffset, searchToken],
    _getAllMatches,
    { refetchOnWindowFocus: false, enabled: !!token && isAdmin, keepPreviousData: true }
  );

  const handleReset = () => {
    setSearchMatchId("");
    setStartDate(null);
    setEndDate(null);
    setSelectedReviewerArray([]);
    setSelectAnalyzedArray([]);
    setSelectedAnalystArray([]);
    setSearchClicked(true);
    setSearchToken((t) => t + 1);
  };

  const handleSearch = () => {
    if ((startDate && !endDate) || (!startDate && endDate)) {
      setErrorModalMessage("Please select both 'Start Date' and 'End Date' to perform a date-based search.");
      setShowErrorModal(true);
      return;
    }

    if (startDate && endDate && moment(endDate).isBefore(moment(startDate), "day")) {
      setErrorModalMessage("'End Date' cannot be before 'Start Date'. Please correct the date range.");
      setShowErrorModal(true);
      return;
    }

    if (startDate && endDate && !(selectAnalyzedArray?.length > 0)) {
      // setErrorModalMessage(
      //   <span>
      //     Please select at least one status from the <b>'Status'</b> dropdown to search within a date range.
      //   </span>
      // );
      // setShowErrorModal(true);
      // return;

      setSelectAnalyzedArray([1, 2, 3, 4, 5, 6, 7, 8, 9]);

       setCurrentOffset(0);
    setSearchClicked(true);
    setSearchToken((t) => t + 1);

    return

    }
    setCurrentOffset(0);
    setSearchClicked(true);
    setSearchToken((t) => t + 1);
  };

  const handleSortSelect = () => {
    setSearchClicked(true);
    setSearchToken((t) => t + 1);
  };

  useEffect(() => {
    if (!isRefetching && !isLoadingMatches) setSearchClicked(false);
  }, [isRefetching, isLoadingMatches]);

  useEffect(() => {
    const analystIdsAndNames = allAnalyst
      ?.map((analyst) => ({ id: analyst.id, name: analyst.name }))
      .sort((a, b) => a.name.localeCompare(b.name));
    setSearchByAnalyst(analystIdsAndNames);
  }, [allAnalyst]);

  const HeaderWithInfo = ({ label, tooltip }) => (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "40px",
        pr: "14px",
      }}
    >
      <Box component="span">{label}</Box>
      <Tooltip
        arrow
        placement="top"
        title={
          <Typography sx={{ fontSize: "11px", lineHeight: 1.4 }}>
            {tooltip}
          </Typography>
        }
      >
        <Box
          component="span"
          tabIndex={0}
          sx={{
            position: "absolute",
            right: 0,
            bottom: "2px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "13px",
            height: "13px",
            color: "var(--text-2)",
            cursor: "help",
            opacity: 0.85,
            "&:hover": {
              opacity: 1,
              color: "var(--text-1)",
            },
          }}
        >
          <InfoOutlined sx={{ fontSize: "13px" }} />
        </Box>
      </Tooltip>
    </Box>
  );

  const ListHeader = () => (
    <TableHead
      sx={{ backgroundColor: "#121213", position: "sticky", zIndex: 999 }}
    >
      <TableRow
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
        }}
      >
        <TableCell
          sx={{
            position: "sticky",
            left: 0,
            zIndex: 999,
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "600",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
            minWidth: "70px",
            borderRight: "1px solid var(--border-1)",
          }}
          component="th"
          scope="row"
        >
          Match ID
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Match Details
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Analysts
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
            minWidth: "100px",
          }}
          align="left"
        >
          Video Uploaded Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
            minWidth: "100px",
          }}
          align="left"
        >
          Assign Date
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
            minWidth: "100px",
          }}
          align="left"
        >
          Analysis Start Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Progress %
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
            minWidth: "100px",
          }}
          align="right"
        >
          Analysis End Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
            minWidth: "100px",
          }}
          align="right"
        >
          Full Completion Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "100%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Last Tagged Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
            minWidth: "100px",
          }}
          align="right"
        >
          Due date
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Status
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Reviewers
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Account Availablity
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          <HeaderWithInfo
            label="Analyst Screen Time"
            tooltip="Its the time duration for which the tagging portal is open on the analyst mobile phone while tagging this match."
          />
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          <HeaderWithInfo
            label="Analysis TAT"
            tooltip="Turnaround time is from Analysis In Progress to Analysis Done."
          />
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          <HeaderWithInfo
            label="Reviewer TAT"
            tooltip="Turnaround time is from Review In Progress to Full Completion."
          />
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          <HeaderWithInfo
            label="Overall Analysis TAT"
            tooltip="Total analysis turnaround is from Analysis In Progress to Full Completion, including analysis time, reviewer time, and time spent fixing analyst errors."
          />
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          <HeaderWithInfo
            label="Client TAT"
            tooltip="Client turnaround time is from Video Uploaded Time to Full Completion Time."
          />
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Game Time
        </TableCell>
        <TableCell
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Total Game Time
        </TableCell>
        <TableCell
          colSpan={3}
          sx={{
            fontSize: { lg: "12px", md: "12px", xs: "10px" },
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "var(--text-1)",
            lineHeight: "120%",
            backgroundColor: "var(--surface-2)",
          }}
          align="center"
        >
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
  const handlePageChange = (_, value) => {
    const link = pageLinks[value - 1];
    if (link) {
      setCurrentPage(link.counter);
      setCurrentOffset(Number(link.params.match(/offset=(\d+)/)?.[1] || 0));
    }
  };

  const currentPageIndex = pageLinks.findIndex((l) => l.is_current) + 1;
  const matchCount = _allMatches?.count || 0;
  const hasActiveFilters = searchMatchId || selectAnalyzedArray?.length > 0 || selectedAnalystArray?.length > 0 || selectedReviewerArray?.length > 0 || startDate || endDate;

  if (fetchingMatches || isLoadingMatches) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", width: "100%", minHeight: "100vh", backgroundColor: "var(--app-bg)", overflow: "hidden" }}>
        <Header label="Admin Portal" tab="management" />
        <Box sx={{ flex: 1, width: "100%", maxWidth: "100%", px: { xs: 1.5, md: 3 }, py: 2, boxSizing: "border-box" }}>
          <Stack spacing={2}>
            <Skeleton variant="rounded" sx={{ width: "100%", height: 52, borderRadius: "12px", bgcolor: "var(--surface-2)" }} />
            <Stack spacing={0}>
              <Skeleton variant="rounded" sx={{ width: "100%", height: 44, borderRadius: "12px 12px 0 0", bgcolor: "var(--surface-2)" }} />
              {[...Array(10)].map((_, i) => (
                <Stack key={i} direction="row" alignItems="center" sx={{ px: 2, py: 1.5, borderBottom: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)" }}>
                  <Skeleton variant="text" width={50} sx={{ mr: 2, bgcolor: "var(--surface-2)" }} />
                  <Skeleton variant="text" width={140} sx={{ mr: 2, bgcolor: "var(--surface-2)" }} />
                  <Skeleton variant="rounded" width={80} height={22} sx={{ mr: 2, borderRadius: "4px", bgcolor: "var(--surface-2)" }} />
                  <Skeleton variant="text" width={80} sx={{ mr: 2, bgcolor: "var(--surface-2)" }} />
                  <Skeleton variant="text" width={80} sx={{ mr: 2, bgcolor: "var(--surface-2)" }} />
                  <Skeleton variant="text" width={80} sx={{ mr: 2, bgcolor: "var(--surface-2)" }} />
                  <Skeleton variant="rounded" width={50} height={24} sx={{ mr: 2, borderRadius: "6px", bgcolor: "var(--surface-2)" }} />
                  <Box sx={{ flex: 1 }} />
                  <Skeleton variant="rounded" width={70} height={24} sx={{ borderRadius: "4px", bgcolor: "var(--surface-2)" }} />
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Box>
      </Box>
    );
  }

  if (!isAdmin) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", width: "100%", minHeight: "100vh", backgroundColor: "var(--app-bg)" }}>
        <Header label="Admin Portal" tab="management" />
        <Stack sx={{ p: 4 }}>
          <Link to="/home" style={{ color: "var(--primary-1)" }}>Back to home</Link>
        </Stack>
      </Box>
    );
  }

  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          root: {
            minWidth: "50px",
          },
        },
      },
    },
  });

  const tatLegendItems = [
    {
      label: "< 24h",
      color: "var(--tat-ok-text)",
      backgroundColor: "var(--tat-ok-bg)",
      borderColor: "#22c55e",
    },
    {
      label: "24-48h",
      color: "var(--tat-warning-text)",
      backgroundColor: "var(--tat-warning-bg)",
      borderColor: "#ef4444",
    },
    {
      label: "> 48h",
      color: "#fff5f5",
      backgroundColor: "#991b1b",
      borderColor: "#dc2626",
    },
  ];

  const TatLegend = () => (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      gap={0.75}
      sx={{
        px: 1,
        py: 0.5,
        border: "1px solid var(--border-1)",
        borderRadius: "4px",
        backgroundColor: "var(--surface-1)",
        minHeight: "36px",
      }}
    >
      <Typography
        sx={{
          color: "var(--text-2)",
          fontFamily: "Poppins",
          fontSize: "11px",
          fontWeight: 700,
          lineHeight: "120%",
          whiteSpace: "nowrap",
        }}
      >
        TAT
      </Typography>
      {tatLegendItems.map((item) => (
        <Box
          key={item.label}
          sx={{
            color: item.color,
            backgroundColor: item.backgroundColor,
            border: "1px solid",
            borderColor: item.borderColor,
            borderRadius: "4px",
            fontFamily: "Poppins",
            fontSize: "11px",
            fontWeight: 700,
            lineHeight: "120%",
            minWidth: "64px",
            px: 0.75,
            py: 0.35,
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          {item.label}
        </Box>
      ))}
    </Stack>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", minHeight: "100vh", backgroundColor: "var(--app-bg)", overflow: "hidden" }}>
      <Header label="Admin Portal" tab="management" />

      <EditDialog
        open={openEdit.show}
        data={openEdit.data}
        handleClose={() => setOpenEdit({ show: false, data: null })}
        refreshData={refetch}
      />

      <Dialog
        open={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        PaperProps={{ sx: { borderRadius: "12px", p: 1, minWidth: "320px" } }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "600", fontSize: "18px", color: "var(--text-1)" }}>
          Selection Required
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: "center", color: "var(--text-2)", fontSize: "14px", mt: 1 }}>
            {errorModalMessage}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            onClick={() => setShowErrorModal(false)}
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              px: 4,
              backgroundColor: "rgba(232, 108, 0, 1)",
              "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" },
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ flex: 1, width: "100%", maxWidth: "100%", margin: "0 auto", px: { xs: 1.5, md: 3 }, py: 2, overflowX: "hidden", overflowY: "auto", boxSizing: "border-box" }}>
        <Stack spacing={2}>
          {/* Toolbar */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              backgroundColor: "var(--surface-1)",
              border: "1px solid var(--border-1)",
              borderRadius: "12px",
              px: 2,
              py: 1,
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flexWrap: "wrap" }}>
              <Tooltip title={filterShown ? "Hide filters" : "Show filters"}>
                <IconButton
                  onClick={() => setFilterShown(!filterShown)}
                  size="small"
                  sx={{
                    backgroundColor: filterShown ? "var(--primary-1)" : hasActiveFilters ? "rgba(232, 108, 0, 0.12)" : "var(--surface-2)",
                    color: filterShown ? "#fff" : hasActiveFilters ? "rgba(232, 108, 0, 1)" : "var(--text-2)",
                    borderRadius: "8px",
                    width: 36,
                    height: 36,
                    "&:hover": { backgroundColor: filterShown ? "var(--primary-1)" : "var(--surface-2)" },
                  }}
                >
                  <FilterListOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
              <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "var(--text-1)", display: { xs: "none", md: "block" } }}>
                Match Management
              </Typography>
              {hasActiveFilters && (
                <Chip
                  label="Filters active"
                  size="small"
                  onDelete={handleReset}
                  sx={{
                    fontSize: "11px",
                    height: "24px",
                    backgroundColor: "rgba(232, 108, 0, 0.12)",
                    color: "rgba(232, 108, 0, 1)",
                    "& .MuiChip-deleteIcon": { color: "rgba(232, 108, 0, 0.6)", fontSize: "16px" },
                  }}
                />
              )}

              {/* Sort toggle */}
              <Stack direction="row" alignItems="center" spacing={0.5} sx={{ display: { xs: "none", md: "flex" } }}>
                <Typography sx={{ fontSize: "11px", color: "var(--text-2)", whiteSpace: "nowrap" }}>Sort by:</Typography>
                <Stack direction="row" sx={{ border: "1px solid var(--border-1)", borderRadius: "8px", overflow: "hidden" }}>
                  {sortOptions.map((opt) => {
                    const active = sortBy?.value === opt.value;
                    return (
                      <Button
                        key={opt.value}
                        size="small"
                        disableElevation
                        onClick={() => { setSortBy(opt); handleSortSelect(); }}
                        sx={{
                          textTransform: "none",
                          fontSize: "12px",
                          height: "32px",
                          px: 1.5,
                          borderRadius: 0,
                          whiteSpace: "nowrap",
                          backgroundColor: active ? "rgba(232,108,0,1)" : "var(--surface-2)",
                          color: active ? "#fff" : "var(--text-2)",
                          "&:hover": {
                            backgroundColor: active ? "rgba(200,93,0,1)" : "var(--surface-1)",
                          },
                          borderRight: "1px solid var(--border-1)",
                          "&:last-child": { borderRight: "none" },
                        }}
                      >
                        {opt.label}
                      </Button>
                    );
                  })}
                </Stack>
              </Stack>

              {/* Download CSV */}
              <Button
                variant="outlined"
                size="small"
                disabled={loading}
                onClick={fetchDataAndDownload}
                startIcon={loading ? <CircularProgress size={14} /> : <DownloadOutlined sx={{ fontSize: "16px !important" }} />}
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  fontSize: "12px",
                  borderColor: "var(--border-1)",
                  color: "var(--text-1)",
                  height: 32,
                  "&:hover": { borderColor: "var(--text-2)", backgroundColor: "var(--surface-2)" },
                }}
              >
                {loading ? "Exporting..." : "Export CSV"}
              </Button>
            </Stack>

            {/* Right side: count + pagination arrows */}
            <Stack direction="row" alignItems="center" spacing={1}>
              {(searchClicked || isRefetching) && <CircularProgress size={18} sx={{ color: "var(--text-2)" }} />}
              <Typography sx={{ fontSize: "13px", color: "var(--text-2)", display: { xs: "none", sm: "block" }, mr: 0.5 }}>
                {matchCount > 0
                  ? `${currentOffset + 1}–${Math.min(currentOffset + pageSize, matchCount)} of ${matchCount}`
                  : "No matches"}
              </Typography>
              {pageLinks.length > 1 && (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <IconButton
                    size="small"
                    disabled={currentPageIndex <= 1}
                    onClick={() => handlePageChange(null, currentPageIndex - 1)}
                    sx={{ width: 30, height: 30, borderRadius: "6px", border: "1px solid var(--border-1)", color: "var(--text-2)", "&.Mui-disabled": { opacity: 0.3 } }}
                  >
                    <ArrowBack sx={{ fontSize: 16 }} />
                  </IconButton>
                  <IconButton
                    size="small"
                    disabled={currentPageIndex >= pageLinks.length}
                    onClick={() => handlePageChange(null, currentPageIndex + 1)}
                    sx={{ width: 30, height: 30, borderRadius: "6px", border: "1px solid var(--border-1)", color: "var(--text-2)", "&.Mui-disabled": { opacity: 0.3 } }}
                  >
                    <ArrowForward sx={{ fontSize: 16 }} />
                  </IconButton>
                </Stack>
              )}
            </Stack>
          </Stack>

          {/* Filter Panel */}
          <Collapse in={filterShown}>
            <Stack
              className="management-filter-panel"
              direction={{ xs: "column", md: "row" }}
              alignItems={{ md: "flex-end" }}
              spacing={1.5}
              sx={{
                backgroundColor: "var(--surface-1)",
                border: "1px solid var(--border-1)",
                borderRadius: "12px",
                p: 1.5,
              }}
            >
                <Stack sx={{ flex: "1.4 1 0", minWidth: 0 }}>
                  <Typography sx={{ fontSize: "11px", fontWeight: 500, color: "var(--text-2)", mb: 0.5 }}>Match ID</Typography>
                  <TextField
                    size="small"
                    placeholder="e.g. 1234 or 100-200"
                    value={searchMatchId}
                    onChange={(e) => setSearchMatchId(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><SearchOutlined sx={{ fontSize: 16, color: "var(--text-2)" }} /></InputAdornment>,
                      sx: { borderRadius: "8px", fontSize: "12px", height: "38px", backgroundColor: "var(--surface-2)", "& fieldset": { borderColor: "var(--border-1)" }, "&:hover fieldset": { borderColor: "var(--text-2)" } },
                    }}
                  />
                </Stack>

                <Stack sx={{ flex: "1 1 0", minWidth: 0 }}>
                  <Typography sx={{ fontSize: "11px", fontWeight: 500, color: "var(--text-2)", mb: 0.5 }}>Analysts</Typography>
                  <FilterSelectField
                    options={searchByAnalyst || []}
                    value={selectedAnalystArray || []}
                    onChange={setSelectedAnalystArray}
                    placeholder="Search..."
                    searchable
                    labelKey="name"
                    valueKey="id"
                  />
                </Stack>

                <Stack sx={{ flex: "1 1 0", minWidth: 0 }}>
                  <Typography sx={{ fontSize: "11px", fontWeight: 500, color: "var(--text-2)", mb: 0.5 }}>Reviewers</Typography>
                  <FilterSelectField
                    options={searchByAnalyst || []}
                    value={selectedReviewerArray || []}
                    onChange={setSelectedReviewerArray}
                    placeholder="Search..."
                    searchable
                    labelKey="name"
                    valueKey="id"
                  />
                </Stack>

                <Stack sx={{ flex: "1 1 0", minWidth: 0 }}>
                  <Typography sx={{ fontSize: "11px", fontWeight: 500, color: "var(--text-2)", mb: 0.5 }}>Status</Typography>
                  <FilterSelectField
                    options={analysisOptions}
                    value={selectAnalyzedArray || []}
                    onChange={setSelectAnalyzedArray}
                    placeholder="Select"
                  />
                </Stack>

                <Stack sx={{ flex: "0 0 auto" }}>
                  <Typography sx={{ fontSize: "11px", fontWeight: 500, color: "var(--text-2)", mb: 0.5 }}>Start Date</Typography>
                  <DatePicker
                    selected={startDate}
                    isClearable
                    onChange={(date) => {
                      if (date && endDate && moment(date).isAfter(endDate, "day")) {
                        toast.error("Start date can't be after end date",{style:{zIndex:9999}});
                        return;
                      }
                      setStartDate(date);
                    }}
                    dateFormat="MM/dd/yyyy"
                    customInput={<CustomDateInput className="management-filter-date-input" value={startDate ? moment(startDate).format("MM/DD/YYYY") : ""} />}
                  />
                </Stack>

                <Stack sx={{ flex: "0 0 auto" }}>
                  <Typography sx={{ fontSize: "11px", fontWeight: 500, color: "var(--text-2)", mb: 0.5 }}>End Date</Typography>
                  <DatePicker
                    selected={endDate}
                    isClearable
                    onChange={(date) => {
                      if (date && startDate && moment(date).isBefore(startDate, "day")) {
                        toast.error("End date can't be before start date");
                        return;
                      }
                      setEndDate(date);
                    }}
                    dateFormat="MM/dd/yyyy"
                    customInput={<CustomDateInput className="management-filter-date-input" value={endDate ? moment(endDate).format("MM/DD/YYYY") : ""} />}
                  />
                </Stack>

                <Stack direction="row" spacing={1} sx={{ flex: "0 0 auto", alignItems: "flex-end" }}>
                  <Button
                    onClick={handleReset}
                    size="small"
                    variant="outlined"
                    sx={{
                      textTransform: "none", borderRadius: "8px", borderColor: "var(--border-1)", color: "var(--text-2)", px: 2, height: 38, fontSize: "13px", whiteSpace: "nowrap",
                      "&:hover": { borderColor: "var(--text-2)", backgroundColor: "var(--surface-2)" },
                    }}
                    startIcon={<CloseOutlined sx={{ fontSize: "16px !important" }} />}
                  >
                    Reset
                  </Button>
                  <Button
                    onClick={handleSearch}
                    size="small"
                    variant="contained"
                    sx={{
                      textTransform: "none", borderRadius: "8px", px: 2.5, height: 38, fontSize: "13px", whiteSpace: "nowrap",
                      backgroundColor: "rgba(232, 108, 0, 1)", "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" },
                    }}
                    startIcon={<SearchOutlined sx={{ fontSize: "16px !important" }} />}
                  >
                    Search
                  </Button>
                </Stack>
            </Stack>
          </Collapse>

          {/* Loading bar */}
          {(searchClicked || isRefetching) && (
            <LinearProgress sx={{ borderRadius: "4px", height: 3, backgroundColor: "var(--surface-2)", "& .MuiLinearProgress-bar": { backgroundColor: "rgba(232, 108, 0, 1)" } }} />
          )}

          {/* Table */}
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              borderRadius: "12px",
              border: "1px solid var(--border-1)",
              overflow: "auto",
              maxWidth: "100%",
              backgroundColor: "var(--surface-1)",
            }}
          >
            <Table stickyHeader size="small" sx={{ borderSpacing: 0, borderCollapse: "separate" }}>
              <TableHead>
                <TableRow>
                  {headerColumns.map((col) => (
                    <TableCell
                      key={col.label}
                      align={col.align}
                      colSpan={col.colSpan || 1}
                      sx={{
                        fontSize: "11px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "var(--text-2) !important",
                        backgroundColor: "var(--surface-2) !important",
                        borderBottom: "1px solid var(--border-1) !important",
                        py: 1.5,
                        whiteSpace: "nowrap",
                        ...(col.sticky && {
                          position: "sticky",
                          left: 0,
                          zIndex: 999,
                          borderRight: "1px solid var(--border-1)",
                        }),
                        ...(col.width && { width: col.width, minWidth: col.width }),
                      }}
                    >
                      {col.tooltip ? (
                        <HeaderWithInfo label={col.label} tooltip={col.tooltip} />
                      ) : (
                        col.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {!searchClicked && !isRefetching && (!_allMatches?.data || _allMatches.data.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={20} sx={{ border: 0 }}>
                      <Stack alignItems="center" justifyContent="center" sx={{ py: 8, gap: 1 }}>
                        <SportsSoccer sx={{ fontSize: 48, color: "var(--text-2)", opacity: 0.3 }} />
                        <Typography sx={{ fontSize: "15px", fontWeight: 500, color: "var(--text-2)" }}>No matches found</Typography>
                        <Typography sx={{ fontSize: "13px", color: "var(--text-2)", opacity: 0.7 }}>Try adjusting your filters</Typography>
                      </Stack>
                    </TableCell>
                  </TableRow>
                )}
                {!searchClicked && !isRefetching && _allMatches?.data?.map((i) => (
                  <MatchCard
                    key={i?.id}
                    data={i}
                    onEditPress={() => setOpenEdit({ data: i, show: true })}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Bottom Pagination */}
          {pageLinks.length > 1 && (
            <Stack direction="row" alignItems="center" justifyContent="center" sx={{ py: 1 }}>
              <Pagination
                count={pageLinks.length}
                page={currentPageIndex}
                onChange={handlePageChange}
                shape="rounded"
                size={isMobile ? "small" : "medium"}
                siblingCount={isMobile ? 0 : 1}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBack, next: ArrowForward }}
                    {...item}
                    sx={{
                      borderRadius: "8px",
                      fontWeight: 500,
                      fontSize: "13px",
                      minWidth: 36,
                      height: 36,
                      color: "var(--text-1)",
                      border: "1px solid var(--border-1)",
                      backgroundColor: "var(--surface-1)",
                      "&.Mui-selected": {
                        backgroundColor: "rgba(232, 108, 0, 1) !important",
                        color: "#fff !important",
                        borderColor: "rgba(232, 108, 0, 1) !important",
                        fontWeight: 700,
                      },
                      "&:hover": { backgroundColor: "var(--surface-2) !important" },
                    }}
                  />
                )}
              />
            </Stack>
          )}
        </Stack>
      </Box>
    </Box>
  );
};
